import { 
    Component, 
    OnInit, 
    ViewChild 
} from "@angular/core";
import { 
    AbstractModal, 
    ModalButtonModel, 
    ModalButtonType, 
    ObjectUtils 
} from "@cv-invision/core";

// Other
import { ClipboardService } from "ngx-clipboard";

@Component({
    selector: 'cv-invision-request-information-partial',
    templateUrl: './request-information-partial-log.component.html',
    styleUrls: ['./request-information-partial-log.component.scss']
})
export class RequestInformationPartialComponent extends AbstractModal implements OnInit {
    @ViewChild('markupEditor', { static: false }) markupEditor;
    public requestInformation: any;
    public copyRequest: Array<ModalButtonModel> = [];

    constructor(private clipboardService: ClipboardService) {
        super();
    }

    public ngOnInit(): void {
        this.requestInformation = this.parseData(this.data.request);
        
        const requestButton: ModalButtonModel = {
            class: 'copy-button',
            icon: 'fad fa-copy',
            type: ModalButtonType.ACTION,
            action: () => this.onCopyCode(this.requestInformation)
        };
        this.copyRequest.push(requestButton);

        const closeButton: ModalButtonModel = {
            name: 'close',
            text: 'Close',
            class: 'btn-sm',
            type: ModalButtonType.ACTION,
            action: this.onDismiss.bind(this)
        };
        this.buttons.push(closeButton);

        setTimeout(() => {
            this.markupEditor?.init();
        }, 200);
    }

    /**
     * Parse data as JSON or XML and format it accordingly
     * @param data The data to parse and format
     */
    parseData(data: any): string {
        try {
            const jsonString = typeof data === 'string' ? data : JSON.stringify(data);
            const jsonObject = JSON.parse(jsonString);
            return JSON.stringify(jsonObject, null, 3);
        } catch (jsonError) {
            try {
				const copy = ObjectUtils.recursiveDeepCopy(data);
                return {...copy};
            } catch (xmlError) {
                console.error('Error parsing data:', jsonError, xmlError);
                return 'Error parsing data';
            }
        }
    }

    /***
     * Copy response code
     */
    onCopyCode(source: string): void {
        this.clipboardService.copy(source);
    }
    
    public onDismiss(): void {
        super.onCancel();
    }
}
